var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('h2',{staticClass:"page-titles"},[_vm._v("Integrations")]),_c('div',{staticClass:"card-holder"},[_c('p',{staticClass:"caption"},[_vm._v("\n      Integrate with Apps to track sales, marketing, ROI and more.\n    ")]),_c('section',{staticClass:"section-holder"},[_c('SalesforceIntegration')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }